import { j as i } from "./jsx-runtime-CZlWR0BA.js";
import { H as t } from "./styled-components.browser.esm-cBExeaUK.js";
const r = (n, e) => e === "lg" ? {
  height: n.spacingInlineLgRem,
  fontSize: "1.2rem"
} : e === "md" ? {
  height: n.spacingInlineMdRem,
  fontSize: "1.2rem"
} : {
  height: n.spacingInlineSmRem,
  fontSize: n.fontSizeXxxs
}, o = t.input`
  border: ${(n) => n.theme.borderWidthHairline} solid ${(n) => n.theme.colorNeutralDarkest};
  outline: none;
  font-family: ${(n) => n.theme.fontFamilyLight};
  padding: ${(n) => n.theme.spacingInlineQuarck};
  border-radius: ${(n) => n.theme.spacingInlineNano};
  ${(n) => r(n.theme, n.inputSize)}
`, s = ({ inputSize: n = "md", ...e }) => /* @__PURE__ */ i.jsx(o, { ...e, inputSize: n }), l = s;
export {
  l as I
};
